import styled from 'styled-components';

export const Logo = styled.img`
  width: 200px;
  height: 150px;
  object-fit: contain;
  margin-top: -30px;
  margin-bottom: -30px;
`;
